// removed by extract-text-webpack-plugin
module.exports = {"marketing":"i-kjF","block":"_1N5cj","image":"_27SJQ","title":"Orlzj","paragraph":"_17amz","footer":"_1JC4K"};